import { POPOVER_SELECTOR, POPOVER_TARGET } from '@anm/constants/embed';
import getThumbnailSrc, { PlayButton } from '@anm/helpers/getThumbnailSrc';
import { VideoSizes } from '@anm/hosting-player';
import { FC, ReactNode } from 'react';

import { EmbedWrapper, ThumbnailImage } from './Wrapper';

type ThumbnailEmbedProps = {
  sizes: VideoSizes;
  isProd: boolean;
  button: PlayButton;
  hostId: string;
  videoName: string;
  children?: ReactNode;
  thumbSrc?: string;
  imgSizeMultiplier?: number;
};

const ThumbnailEmbed: FC<ThumbnailEmbedProps> = props => {
  const { sizes, hostId, videoName, children } = props;

  const thumbnailSrc = getThumbnailSrc(props);

  return (
    <EmbedWrapper className={POPOVER_SELECTOR} data-id={hostId} data-width={sizes.width} data-height={sizes.height}>
      <div data-target={POPOVER_TARGET}>{children || <ThumbnailImage src={thumbnailSrc} alt={videoName} />}</div>
    </EmbedWrapper>
  );
};

export default ThumbnailEmbed;
